// Provides some of the modularized code for old pages on desktop. Some of them can't be moved at this time.
import { addToCart } from 'features/cart';
import { showAddToCartFailureModal } from 'features/cart/desktop';

window.lp.utils.cart = {
	...window.lp.utils.cart,
	addToCart,
	showAddToCartFailureModal
};
